import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteCompetition = async ({ orgId, competitionId }) => {
  const url = `v1/orgs/${orgId}/competitions/${competitionId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default deleteCompetition
